module.exports = __webpack_public_path__ + "img/en_espera.7ba1c5ad.svg";